// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"6529b65c","988":"d39e8061","3581":"d39e8061","3957":"d39e8061","4920":"d39e8061","5621":"d39e8061","6144":"d39e8061","6353":"ab2439eb","6371":"d39e8061","6533":"e997e87f","8462":"f54f2388"}[chunkId] + ".chunk.css";
};